import React from 'react';

import '../sass/default.scss';
import './Layout.scss';

import { Header } from './Header';

type LayoutProps = {
  children: NonNullable<React.ReactNode>;
};

export const Layout: React.FC<LayoutProps> = React.memo((props) => {
  return (
    <div className='e-layout'>
      <Header />
      {props.children}
    </div>
  );
});
